export const ABOUT_VALUES = [
  { title: "Lượt tiếp cận", number: "39.700+" },
  { title: "Lượt tương tác", number: "5.300+" },
  { title: "Lượt thích", number: "5.100+" },
  { title: "Lượt theo dõi", number: "5.700+" },
];
